
export default {
    main: {
        1: [
            "話し手の話をよくききながら、",
            "冷静に話をききながら、",
            "傾聴の姿勢をとりながら、",
            "しっかり聞くターンを設けながら、",
            "熟慮の雰囲気をかもし出しながら、",
        ],
        2: [
            "今日は独壇場で、",
            "議上を大いに回して、",
            "マイクを半独占状態で、",
            "発言回数ナンバーワンで、",
            "会議を支配していて、",
        ],
        3: [
            "発言回数も良かったし、",
            "相手の話も聞きながら、",
            "よいバランスで発言し、",
            "適度に発言していたし、",
            "交互に発言していたし、",
        ],
        4: [
            "積極的に発言していたし、",
            "活発に発言していたし、",
            "多くの発言をしていたし、",
            "たくさん発言をしていたし、",
            "何度も発言をしていたし、",
        ],
        5: [
            "大胆に発言していたし、",
            "会議を引っ張っていたし、",
            "圧倒的に発言をしていたし、",
            "縦横無尽に発言をしていたし、",
            "最大限に発言をしていたし、",
        ],
    },
    title: {
        1: [
            "鋭いカウンタータイプ！？",
        ],
        2: [
            "怒濤の発言量！？",
        ],
        3: [
            "冴えるバランス感覚！",
        ],
        4: [
            "勇猛果敢な発言数！",
        ],
        5: [
            "発言量の黄金比！",
        ],
    },
    comment: {
        1: [
            "会議の要所で効く発言！でも待機時間長すぎ？",
        ],
        2: [
            "十字砲火の発言数！でもちょっとノド休めません？",
        ],
        3: [
            "攻守のバランスの良さ！会議の流れ読んでますね。",
        ],
        4: [
            "積極的に攻める姿勢！その姿、会議の要石！",
        ],
        5: [
            "絶対的な発言バランス今日の会議の中心核！",
        ],
    }
}

